import { render } from "./riepilogoModal.vue?vue&type=template&id=0e4bb024&scoped=true&ts=true"
import script from "./riepilogoModal.vue?vue&type=script&lang=ts"
export * from "./riepilogoModal.vue?vue&type=script&lang=ts"

import "./riepilogoModal.vue?vue&type=style&index=0&id=0e4bb024&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4bb024"]])

export default __exports__